// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e6415995","782":"a8d482b2"}[chunkId] + ".chunk.js";
};